import { create } from 'zustand/react';

interface ChangelogDropdownState {
  /** Opens the changelog dropdown anchored at the header icon. Null while the header dropdown isn't mounted. */
  open: (() => void) | null;
  setOpen: (open: (() => void) | null) => void;
}

export const useChangelogDropdownStore = create<ChangelogDropdownState>((set) => ({
  open: null,
  setOpen: (open) => set({ open }),
}));
